// extracted by mini-css-extract-plugin
module.exports = {"Color":"Styles_Color__3iL4k","Active":"Styles_Active__1dpe0"};